import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import './Admin.css';
import CollapseCard from '../../components/CollapseCard/CollapseCard';
import AdminUsers from './AdminUsers';
import AdminRoles from './AdminRoles';
import AdminPermissions from './AdminPermissions';
import * as utilities from '../../utilities';
import {
    Row,
    Col,
} from 'reactstrap';
import PermissionWrapper from '../../auth/PermissionWrapper';
import { Prompt } from 'react-router-dom';
import CompanyContext from '../../auth/CompanyContext';

class AdminContainer extends Component {
    static contextType = CompanyContext;

    constructor(props) {
        super(props);
        this.blankUser = {
            auth0: '',
            firstName: '',
            lastName: '',
            title: '',
            emailAddress: '',
            active: 1,
            alwaysFirstLast: false,
            hasDocumentSignature: false,
            documentSignatureFilename: '',
            documentSignatureDataUrl: '',
            documentSignaturePreview: '',
            removeDocumentSignature: false,
            roles: [],
            companyMetadata: []
        }
        this.blankRole = {
            id: 0,
            role: '',
            description: '',
            active: true,
            order: 0,
            permissions: [],
            users: []
        }
        this.blankPermission = {
            id: 0,
            permission: '',
            description: '',
            api: '',
            method: '',
            active: true,
            order: 0,
            roles: []
        }
        this.state = {
            users: [],
            newUser: { ...this.blankUser },
            editUser: { ...this.blankUser },
            roles: [],
            newRole: { ...this.blankRole },
            editRole: { ...this.blankRole },
            permissions: [],
            newPermission: { ...this.blankPermission },
            editPermission: { ...this.blankPermission },
            isLoaded: 0,
            unsavedChanges: false
        };
    }

    componentDidMount() {
        this.getUsers();
        this.getRoles();
        this.getPermissions();
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    getUsers = () => {
        fetch('/api/users/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState((prevState, props) => {
                    let return_value = {
                        users: results.data,
                        isLoaded: prevState.isLoaded + 1
                    };
                    return return_value;
                });
            });
    }

    getRoles = () => {
        fetch('/api/roles/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState((prevState, props) => {
                    let return_value = {
                        roles: results.data,
                        isLoaded: prevState.isLoaded + 1
                    };
                    return return_value;
                });
            });
    }

    getPermissions = () => {
        fetch('/api/permissions/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState((prevState, props) => {
                    let return_value = {
                        permissions: results.data,
                        isLoaded: prevState.isLoaded + 1
                    };
                    return return_value;
                });
            });
    }

    getCompanyMetadataPayload = () => {
        const existingCompanies = Array.isArray(this.state.editUser.companyMetadata)
            ? this.state.editUser.companyMetadata
            : [];
        const currentCompany = this.context.company;
        const existingCurrentCompany = existingCompanies.find(company => company.company === currentCompany) || {};
        const currentCompanyFromClaims = Array.isArray(this.props.companies)
            ? this.props.companies.find(company => company.company === currentCompany) || {}
            : {};
        const updatedCurrentCompany = {
            company: currentCompany,
            label: existingCurrentCompany.label || currentCompanyFromClaims.label || currentCompany,
            role: existingCurrentCompany.role || currentCompanyFromClaims.role || 'user',
            active: this.state.editUser.active !== false && this.state.editUser.active !== 0,
            use_mfa: existingCurrentCompany.use_mfa === true || currentCompanyFromClaims.use_mfa === true
        };

        if (existingCurrentCompany.company) {
            return existingCompanies.map(company =>
                company.company === currentCompany ? updatedCurrentCompany : company
            );
        }

        return existingCompanies.concat([updatedCurrentCompany]);
    }

    handleAddUser = (e) => {
        let userId = '';
        fetch('/api/auth/', {
            method: 'POST',
            body: JSON.stringify({
                email: this.state.newUser.emailAddress,
                firstName: this.state.newUser.firstName,
                lastName: this.state.newUser.lastName,
                // name: this.state.newUser.firstName + ' ' + this.state.newUser.lastName,
                companyDatabase: this.context.company,
                companyName: this.props.companies.find(company => company.company === this.context.company)?.label || ''
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    userId = results.data.user_id;
                    fetch('/api/users/', {
                        method: 'POST',
                        body: JSON.stringify({
                            firstName: this.state.newUser.firstName,
                            lastName: this.state.newUser.lastName,
                            title: this.state.newUser.title,
                            emailAddress: this.state.newUser.emailAddress,
                            auth0: userId.split('|')[1],
                            active: this.state.newUser.active,
                            alwaysFirstLast: this.state.newUser.alwaysFirstLast
                        }),
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.props.clientToken,
                            'X-Database': this.context.company
                        }
                    })
                        .then(results2 => results2.json())
                        .then(results2 => {
                            if (results2.success) {
                                this.setState({
                                    isLoaded: 2,
                                    unsavedChanges: false
                                }, () => {
                                    utilities.addToast('User successfully added.', 5, 'success');
                                    this.getUsers();
                                    this.handlePasswordReset(userId.split('|')[1], this.state.newUser);
                                })
                            } else {
                                utilities.addToast('Unable to add user in application.', 5, 'danger');
                            }
                        });
                } else {
                    utilities.addToast('Unable to add user in Auth0.', 5, 'danger')
                }
            })
            .catch(() => {
                utilities.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handlePasswordReset = (auth0, user) => {
        fetch('/api/auth/reset', {
            method: 'POST',
            body: JSON.stringify({
                auth0: 'auth0|' + auth0,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    fetch('/api/mail/', {
                        method: 'POST',
                        body: JSON.stringify({
                            from: `SEC Database Application <noreply@cssisolutions.com>`,
                            to: `${user.firstName} ${user.lastName} <${user.emailAddress}>`,
                            subject: 'Password Reset Link',
                            message: `<p><a href="${results.data.ticket}">Click Here to Reset Your Password</a></p>
                            <p><a href="https://sec-database-project.herokuapp.com/">Login to the SEC Database Application</a></p>`,
                        }),
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.props.clientToken,
                            'X-Database': this.context.company
                        }
                    }).then(async results => {
                        const mailResults = await results.json().catch(() => ({}));
                        if (results.status === 200) {
                            utilities.addToast('Password reset email sent.', 5, 'success')
                        } else {
                            const message = mailResults?.error?.message || 'Email delivery failed.';
                            utilities.addToast(`User created, but password reset email was not sent. ${message}`, 10, 'warning');
                        }
                    });
                } else {
                    utilities.addToast('User created, but unable to create password reset link.', 10, 'warning')
                }
            })
            .catch(() => {
                utilities.addToast('User created, but password reset email could not be sent.', 10, 'warning');
            })
    }

    onEditUser = (auth0) => {
        const user = [...this.state.users].filter(item => item.Auth0 === auth0)[0];
        this.setState(() => {
            return {
                editUser: {
                    auth0: auth0,
                    firstName: user['First Name'],
                    lastName: user['Last Name'],
                    title: user.Title || '',
                    emailAddress: user['Email Address'],
                    active: user.Active,
                    alwaysFirstLast: user['AlwaysFirstLast'],
                    hasDocumentSignature: user['Has Document Signature'] === true || user['Has Document Signature'] === 1,
                    documentSignatureFilename: user['Document Signature Filename'] || '',
                    documentSignatureDataUrl: '',
                    documentSignaturePreview: '',
                    removeDocumentSignature: false,
                    roles: user.Roles,
                    companyMetadata: []
                }
            }
        }, () => {
            if (user['Has Document Signature'] === true || user['Has Document Signature'] === 1) {
                fetch(`/api/users/${encodeURIComponent(auth0)}/document-signature`, {
                    headers: {
                        'Authorization': 'Bearer ' + this.props.clientToken,
                        'X-Database': this.context.company
                    }
                })
                    .then(response => response.ok ? response.blob() : Promise.reject(new Error('Unable to load signature')))
                    .then(blob => {
                        const reader = new FileReader();
                        reader.onload = () => this.setState(prevState => ({
                            editUser: { ...prevState.editUser, documentSignaturePreview: reader.result }
                        }));
                        reader.readAsDataURL(blob);
                    })
                    .catch(() => {});
            }
            fetch('/api/auth/companies/' + encodeURIComponent(auth0) + '?' + new URLSearchParams({
                email: user['Email Address'] || ''
            }).toString(), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken,
                    'X-Database': this.context.company
                }
            })
                .then(results => results.json())
                .then(results => {
                    const companies = Array.isArray(results.data) ? results.data : [];
                    this.setState(prevState => ({
                        editUser: {
                            ...prevState.editUser,
                            companyMetadata: companies
                        }
                    }));
                });
        })
    }

    onDocumentSignatureFile = (file) => {
        if (!file) return;
        if (file.type !== 'image/png') {
            utilities.addToast('Document signature must be a PNG image.', 5, 'warning');
            return;
        }
        const reader = new FileReader();
        reader.onload = () => this.setState(prevState => ({
            editUser: {
                ...prevState.editUser,
                documentSignatureDataUrl: reader.result,
                documentSignaturePreview: reader.result,
                documentSignatureFilename: file.name,
                removeDocumentSignature: false
            },
            unsavedChanges: true
        }));
        reader.readAsDataURL(file);
    }

    onRemoveDocumentSignature = () => {
        this.setState(prevState => ({
            editUser: {
                ...prevState.editUser,
                documentSignatureDataUrl: '',
                documentSignaturePreview: '',
                documentSignatureFilename: '',
                removeDocumentSignature: true
            },
            unsavedChanges: true
        }));
    }

    saveDocumentSignature = () => {
        const user = this.state.editUser;
        if (!user.documentSignatureDataUrl && !user.removeDocumentSignature) return Promise.resolve({ success: true });
        return fetch(`/api/users/${encodeURIComponent(user.auth0)}/document-signature`, {
            method: user.removeDocumentSignature ? 'DELETE' : 'PUT',
            body: user.removeDocumentSignature ? undefined : JSON.stringify({
                documentSignatureDataUrl: user.documentSignatureDataUrl,
                filename: user.documentSignatureFilename
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        }).then(async response => {
            const result = await response.json().catch(() => ({}));
            if (!response.ok || !result.success) throw new Error(result.error || 'Unable to save document signature');
            return result;
        });
    }

    onChangeUser = (e, type) => {
        e.persist();
        this.setState((prevState) => {
            let thisUser = (type === 'edit') ? prevState.editUser : prevState.newUser;
            switch (e.target.name) {
                case "active":
                case "alwaysFirstLast":
                    thisUser[e.target.name] = !thisUser[e.target.name];
                    break;
                case "roles":
                    const id = parseInt(String(e.target.id).split('_')[1]);
                    const index = thisUser.roles.findIndex(item => item === id);
                    if (index > -1) thisUser.roles.splice(index, 1);
                    if (e.target.checked) thisUser.roles.push(id);
                    break;
                default:
                    thisUser[e.target.name] = e.target.value;
            }
            return (type === 'edit')
                ? {
                    editUser: thisUser,
                    unsavedChanges: true
                }
                : {
                    newUser: thisUser,
                    unsavedChanges: true
                };
        });
    }

    handleCancelUser = () => {
        this.setState({
            editUser: { ...this.blankUser },
            unsavedChanges: false
        })
    }

    handleEditUser = () => {
        fetch('/api/users/' + this.state.editUser.auth0, {
            method: 'PUT',
            body: JSON.stringify({
                firstName: this.state.editUser.firstName,
                lastName: this.state.editUser.lastName,
                title: this.state.editUser.title,
                emailAddress: this.state.editUser.emailAddress,
                active: this.state.editUser.active,
                roles: this.state.editUser.roles,
                alwaysFirstLast: this.state.editUser.alwaysFirstLast
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.saveDocumentSignature().then(() => fetch('/api/auth/companies/' + encodeURIComponent(this.state.editUser.auth0), {
                        method: 'PUT',
                        body: JSON.stringify({
                            emailAddress: this.state.editUser.emailAddress,
                            companies: this.getCompanyMetadataPayload()
                        }),
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.props.clientToken,
                            'X-Database': this.context.company
                        }
                    }))
                        .then(results2 => results2.json())
                        .then(results2 => {
                            if (results2.success) {
                                let users = [...this.state.users];
                                const index = users.findIndex(item => item.Auth0 === this.state.editUser.auth0);
                                users[index] = {
                                    'First Name': this.state.editUser.firstName,
                                    'Last Name': this.state.editUser.lastName,
                                    Title: this.state.editUser.title,
                                    'Email Address': this.state.editUser.emailAddress,
                                    Active: this.state.editUser.active,
                                    Auth0: this.state.editUser.auth0,
                                    Roles: this.state.editUser.roles,
                                    AlwaysFirstLast: this.state.editUser.alwaysFirstLast,
                                    'Has Document Signature': this.state.editUser.removeDocumentSignature ? false : Boolean(this.state.editUser.documentSignatureDataUrl || this.state.editUser.hasDocumentSignature),
                                    'Document Signature Filename': this.state.editUser.documentSignatureFilename
                                };
                                this.setState({
                                    users: users,
                                    editUser: { ...this.blankUser },
                                    unsavedChanges: false
                                }, () => this.props.refreshUser());
                            } else {
                                utilities.addToast('Unable to update Auth0 company assignments.', 5, 'danger');
                            }
                        })
                        .catch(error => utilities.addToast(error.message || 'Unable to save document signature.', 7, 'danger'));
                }
            });
    }

    onChangeRole = (e, type) => {
        e.persist();
        this.setState((prevState) => {
            let thisRole = (type === 'edit') ? prevState.editRole : prevState.newRole;
            switch (e.target.name) {
                case "active":
                    thisRole[e.target.name] = !thisRole[e.target.name];
                    break;
                case "permissions":
                    const id = parseInt(String(e.target.id).split('_')[1]);
                    const index = thisRole.permissions.findIndex(item => item === id);
                    if (index > -1) thisRole.permissions.splice(index, 1);
                    if (e.target.checked) thisRole.permissions.push(id);
                    break;
                case "users":
                    const userId = String(e.target.id).split('_')[1];
                    const roleId = parseInt(String(e.target.id).split('_')[2]);
                    const userIndex = this.state.users.findIndex(item => item.Auth0 === userId);
                    const roleIndex = this.state.users[userIndex].Roles.findIndex(item => item === roleId);
                    if (roleIndex > -1) this.state.users[userIndex].Roles.splice(roleIndex, 1);
                    if (e.target.checked) this.state.users[userIndex].Roles.push(roleId);
                    break;
                default:
                    thisRole[e.target.name] = e.target.value;
            }
            return (type === 'edit')
                ? {
                    editRole: thisRole,
                    unsavedChanges: true
                }
                : {
                    newRole: thisRole,
                    unsavedChanges: true
                };
        });
    }

    onEditRole = (id) => {
        const role = [...this.state.roles].filter(item => item.ID === id)[0];
        this.setState(() => {
            return {
                editRole: {
                    id: id,
                    role: role.Role,
                    description: role.Description,
                    active: role.Active,
                    order: role.Order,
                    permissions: role.Permissions,
                    users: [...this.state.users].filter(user => user.Roles.findIndex(i => i === id) > -1).map(user => user.Auth0)
                }
            }
        })
    }

    onDeleteRole = (id) => {
        fetch('/api/roles/' + id, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.data) {
                    let roles = [...this.state.roles];
                    roles.splice(roles.findIndex(item => item.ID === id), 1);
                    this.setState({
                        roles: roles,
                        editRole: { ...this.blankRole },
                        unsavedChanges: false
                    });
                }
            });
    }

    handleCancelRole = () => {
        this.setState({
            editRole: { ...this.blankRole },
            unsavedChanges: false
        })
    }

    handleEditRole = () => {
        fetch('/api/roles/' + this.state.editRole.id, {
            method: 'PUT',
            body: JSON.stringify({
                role: this.state.editRole.role,
                description: this.state.editRole.description,
                active: this.state.editRole.active,
                order: this.state.editRole.order,
                users: [...this.state.users].filter(user => user.Roles.findIndex(role => role === this.state.editRole.id) > -1).map(user => user.Auth0),
                permissions: this.state.editRole.permissions
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.data) {
                    let roles = [...this.state.roles];
                    const index = roles.findIndex(item => item.ID === this.state.editRole.id);
                    roles[index] = {
                        Role: this.state.editRole.role,
                        Description: this.state.editRole.description,
                        Active: this.state.editRole.active,
                        Order: this.state.editRole.order,
                        ID: this.state.editRole.id,
                        Permissions: this.state.editRole.permissions
                    };
                    this.setState({
                        roles: roles,
                        editRole: { ...this.blankRole },
                        unsavedChanges: false
                    }, () => this.props.refreshUser());
                }
            });
    }

    handleAddRole = (e) => {
        let newOrder = Math.max(...this.state.roles.map(i => i['Order']), 0) + 10;
        fetch('/api/roles/', {
            method: 'POST',
            body: JSON.stringify({
                role: this.state.newRole.role,
                description: this.state.newRole.description,
                active: this.state.newRole.active,
                order: newOrder
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (parseInt(results.data) > 0) {
                    let roles = [...this.state.roles];
                    roles.push({
                        ID: results.data,
                        Role: this.state.newRole.role,
                        Description: this.state.newRole.description,
                        Active: this.state.newRole.active,
                        Order: newOrder
                    });
                    this.setState({
                        roles: roles,
                        newRole: { ...this.blankRole },
                        unsavedChanges: false
                    });
                }
            });
    }

    onChangePermission = (e, type) => {
        e.persist();
        this.setState((prevState) => {
            let thisPermission = (type === 'edit') ? prevState.editPermission : prevState.newPermission;
            switch (e.target.name) {
                case "active":
                    thisPermission[e.target.name] = !thisPermission[e.target.name];
                    break;
                case "roles":
                    const roleId = parseInt(String(e.target.id).split('_')[1]);
                    const permissionId = parseInt(String(e.target.id).split('_')[2]);
                    const roleIndex = this.state.roles.findIndex(item => item.ID === roleId);
                    const permissionIndex = this.state.roles[roleIndex].Permissions.findIndex(item => item === permissionId);
                    if (permissionIndex > -1) this.state.roles[roleIndex].Permissions.splice(permissionIndex, 1);
                    if (e.target.checked) this.state.roles[roleIndex].Permissions.push(permissionId);
                    break;
                default:
                    thisPermission[e.target.name] = e.target.value;
            }
            return (type === 'edit')
                ? {
                    editPermission: thisPermission,
                    unsavedChanges: true
                }
                : {
                    newPermission: thisPermission,
                    unsavedChanges: true
                };
        });
    }

    onEditPermission = (id) => {
        const permission = [...this.state.permissions].filter(item => item.ID === id)[0];
        this.setState(() => {
            return {
                editPermission: {
                    id: id,
                    permission: permission.Permission != null ? permission.Permission : '',
                    description: permission.Description != null ? permission.Description : '',
                    api: permission.api != null ? permission.api : '',
                    method: permission.method != null ? permission.method : '',
                    active: permission.Active,
                    order: permission.Order
                }
            }
        })
    }

    onDeletePermission = (id) => {
        fetch('/api/permissions/' + id, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.data) {
                    let permissions = [...this.state.permissions];
                    permissions.splice(permissions.findIndex(item => item.ID === id), 1);
                    this.setState({
                        permissions: permissions,
                        editPermission: { ...this.blankPermission },
                        unsavedChanges: false
                    });
                }
            });
    }

    handleCancelPermission = () => {
        this.setState({
            editPermission: { ...this.blankPermission },
            unsavedChanges: false
        })
    }

    handleEditPermission = () => {
        fetch('/api/permissions/' + this.state.editPermission.id, {
            method: 'PUT',
            body: JSON.stringify({
                permission: this.state.editPermission.permission,
                description: this.state.editPermission.description,
                api: this.state.editPermission.api,
                method: this.state.editPermission.method,
                active: this.state.editPermission.active,
                order: this.state.editPermission.order,
                roles: [...this.state.roles].filter(role => role.Permissions.findIndex(permission => permission === this.state.editPermission.id) > -1).map(role => role.ID)
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.data) {
                    let permissions = [...this.state.permissions];
                    const index = permissions.findIndex(item => item.ID === this.state.editPermission.id);
                    permissions[index] = {
                        Permission: this.state.editPermission.permission,
                        Description: this.state.editPermission.description,
                        api: this.state.editPermission.api,
                        method: this.state.editPermission.method,
                        Active: this.state.editPermission.active,
                        Order: this.state.editPermission.order,
                        ID: this.state.editPermission.id
                    };
                    this.setState({
                        permissions: permissions,
                        editPermission: { ...this.blankPermission },
                        unsavedChanges: false
                    }, () => this.props.refreshUser());
                }
            });
    }

    handleAddPermission = (e) => {
        let newOrder = Math.max(...this.state.permissions.map(i => i['Order']), 0) + 10;
        fetch('/api/permissions/', {
            method: 'POST',
            body: JSON.stringify({
                permission: this.state.newPermission.permission,
                description: this.state.newPermission.description,
                api: this.state.newPermission.api,
                method: this.state.newPermission.method,
                active: this.state.newPermission.active,
                order: newOrder
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (parseInt(results.data) > 0) {
                    let permissions = [...this.state.permissions];
                    permissions.push({
                        ID: results.data,
                        Permission: this.state.newPermission.permission,
                        Description: this.state.newPermission.description,
                        api: this.state.newPermission.api,
                        method: this.state.newPermission.method,
                        Active: this.state.newPermission.active,
                        Order: newOrder
                    });
                    this.setState({
                        permissions: permissions,
                        newPermission: { ...this.blankPermission },
                        unsavedChanges: false
                    });
                }
            });
    }

    render() {

        return (
            (this.state.isLoaded === 3) ?
                <>
                    <Prompt
                        when={this.state.unsavedChanges}
                        message="You have unsaved changes, are you sure you want to leave?"
                    />
                    <PermissionWrapper {...this.props} allowedPermission="Show Secondary Ribbon" hidden={true}>
                        <Row>
                            <Col md={12} className='text-center'>
                                <h1>Users</h1>
                            </Col>
                        </Row>
                    </PermissionWrapper>
                    <CollapseCard title="Users" open={true}>
                        <AdminUsers
                            clientToken={this.props.clientToken}
                            users={this.state.users}
                            roles={this.state.roles}
                            newUser={this.state.newUser}
                            editUser={this.state.editUser}
                            onChange={this.onChangeUser}
                            onEdit={this.onEditUser}
                            handleAdd={this.handleAddUser}
                            handleEdit={this.handleEditUser}
                            handleCancel={this.handleCancelUser}
                            onDocumentSignatureFile={this.onDocumentSignatureFile}
                            onRemoveDocumentSignature={this.onRemoveDocumentSignature}
                        />
                    </CollapseCard>
                    <CollapseCard title="Roles" open={true}>
                        <AdminRoles
                            clientToken={this.props.clientToken}
                            users={this.state.users}
                            roles={this.state.roles}
                            permissions={this.state.permissions}
                            newRole={this.state.newRole}
                            editRole={this.state.editRole}
                            onChange={this.onChangeRole}
                            onEdit={this.onEditRole}
                            onDelete={this.onDeleteRole}
                            handleAdd={this.handleAddRole}
                            handleEdit={this.handleEditRole}
                            handleCancel={this.handleCancelRole}
                        />
                    </CollapseCard>
                    <CollapseCard title="Permissions" open={true}>
                        <AdminPermissions
                            clientToken={this.props.clientToken}
                            roles={this.state.roles}
                            permissions={this.state.permissions}
                            newPermission={this.state.newPermission}
                            editPermission={this.state.editPermission}
                            onChange={this.onChangePermission}
                            onEdit={this.onEditPermission}
                            onDelete={this.onDeletePermission}
                            handleAdd={this.handleAddPermission}
                            handleEdit={this.handleEditPermission}
                            handleCancel={this.handleCancelPermission}
                        />
                    </CollapseCard>
                </>
                :
                <h3>Loading...</h3>
        );

    }
}

export default AdminContainer;
